import React, { useContext } from 'react';
import { AddressSelectionContext } from './AddressSelectionProvider';
import { RestaurantSearch } from './components/restaurant-search';
import { DeliveryAddressSelection } from './DeliveryAddressSelection';
import { OrderType } from '../../types';

export const OrderTypeSpecificAddressSelection: React.FC = () => {
  const { orderType } = useContext(AddressSelectionContext);

  switch (orderType) {
    case OrderType.DELIVERY:
      return <DeliveryAddressSelection />;
    default:
      return <RestaurantSearch placeholder="Hae ravintoloita" />;
  }
};
